interface SignboardsIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const SignboardsIcon = (props: SignboardsIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <g>
        <path
          style={{ fill: fillColor }}
          d="M27,7.6H12.2c-0.6,0-1.1,0.5-1.1,1.1v20.9c0,0.6,0.5,1.1,1.1,1.1h1.6v3.7h1.2v-3.8h9.2v3.8h1.2v-3.8H27c0.6,0,1-0.5,1-1V8.7
            C28.1,8.1,27.6,7.6,27,7.6z M26.9,8.8v14H12.3v-14C12.3,8.8,26.9,8.8,26.9,8.8z M12.3,29.4V24h14.6v5.4H12.3z"
        />
      </g>
    </svg>
  )
}

export default SignboardsIcon
